import { BaseURL } from "../../config/axios";
import { Pagination } from "@nextui-org/react";
import paginationHelper from "../../helper/paginationHelper";
import { Link } from "react-router-dom";
import './artist.css'

const Artist = ({ currentpage, setCurrentpage, artist, painting, pagination }) => {
    return (
        <>
            {!!Object.keys(artist).length &&
                <div className="container text-center" dir="rtl">
                    <div className="my-8">
                        {artist?.header3 && <h3 className="title text-primary mb-6">{artist?.header3}</h3>}
                        {artist?.header4 && <h5 className="text-center text-red-900 mb-6">{artist?.header4}</h5>}
                        <div className="grid xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 items-stretch w-full gap-3">
                            {!!painting.length && painting.map(p => {
                                return (
                                    <div className="w-full col-span-1 p-1 pb-2">
                                        <div className="flex flex-col border rounded-lg bg-gray-100 border-gray-300 text-center h-full shadow-lg pb-4">
                                            <div className="py-2 grow">
                                                <Link to={`/product/${p.slug}`} className="centerOfParent overflow-hidden h-full w-full">
                                                    <img className="max-w-full max-h-48 object-contain"
                                                        width={100} height={100}
                                                        layout='responsive'
                                                        style={{ width: '100%', height: '100%' }} // optional
                                                        src={BaseURL + p.images[0]?.path}
                                                        alt={p.title_persian} title={p.title_persian} />
                                                </Link>
                                            </div>
                                            <div className="p-2">
                                                <div className="text-lg text-primary font-bold">
                                                    <Link className="line-clamp-1" to={`/product/${p.slug}`} title={p.title_persian}>{p.title_persian}</Link>
                                                </div>
                                                <hr className="my-2 border-gray-400" />
                                                <div>{p.category?.title}</div>
                                                <br />
                                                <div className="text-sm">{p.year}</div>
                                                <hr className="mt-2 mb-6 border-gray-400" />
                                                <Link to={`/product/${p.slug}`}
                                                    className="text-white bg-main focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center">انتخاب تابلو</Link>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div dir="auto" className="centerOfParent mt-4">
                        {!!painting.length && pagination.current > 1 &&
                            <Pagination size='sm'
                                total={Math.ceil(pagination.current)}
                                color="primary"
                                page={currentpage}
                                onChange={(e) => { setCurrentpage(e); paginationHelper() }}
                                showControls
                            />}
                    </div>
                    <div className="my-10 mx-5">
                        <div className={`text-justify custom px-5 border-r-[5px] border-primary`} dangerouslySetInnerHTML={{ __html: artist.body }} />
                    </div>
                </div>
            }
        </>
    );
};

export default Artist;